/* istanbul ignore file */
// we don't test SVGs without arguments
import React from 'react'
import PropTypes from 'prop-types'
import { IconWideAngleBracketSVG } from './component.styles'

const IconWideAngleBracket = ({
  color = '#3C6E90',
  height = 12,
  rotate = 0,
  width = 7,
}) => {
  const heightWithUnits = `${height}px`
  const widthWithUnits = `${width}px`

  const viewBox = `0 0 ${width} ${height}`

  return (
    <IconWideAngleBracketSVG
      fill="none"
      height={heightWithUnits}
      rotate={rotate}
      viewBox={viewBox}
      width={widthWithUnits}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L6 6L1 11"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </IconWideAngleBracketSVG>
  )
}

IconWideAngleBracket.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  rotate: PropTypes.number,
  width: PropTypes.number,
}

export default IconWideAngleBracket
